package api


sealed class DayOfWeek(var index: Int, val isoDay: Int, val label: String) {
    data object MONDAY : DayOfWeek(2, 1, "MON")
    data object TUESDAY : DayOfWeek(4, 2, "TUE")
    data object WEDNESDAY : DayOfWeek(8, 3, "WEN")
    data object THURSDAY : DayOfWeek(16, 4, "THU")
    data object FRIDAY : DayOfWeek(32, 5, "FRI")
    data object SATURDAY : DayOfWeek(64, 6, "SAT")
    data object SUNDAY : DayOfWeek(128, 7, "SUN")

    infix fun match(index: Int): Boolean = this.index and index > 0

    fun getDayOfYesterday(): DayOfWeek {
        return all.getOrNull(all.indexOfFirst { index == it.index } - 1) ?: SUNDAY
    }

    companion object {
        const val allDaysIndex = 254
        val all by lazy {
            arrayOf(MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY, SUNDAY)
        }
        fun iso(isoDay: Int): DayOfWeek {
            return all.firstOrNull { it.isoDay == isoDay } ?: MONDAY
        }

        operator fun get(index: Int): DayOfWeek {
            return all.firstOrNull { it.index == index } ?: MONDAY
        }
    }
}
